module.exports = __webpack_public_path__ + "static/img/new1.ead687d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/szrt_revision/teachingDetail/list/mockexamination/imgs/new1.png
// module id = OU0E
// module chunks = 96